/*
 * @Description: 
 * @Author: ywj
 * @Date: 2025-04-18 14:23:58
 * @LastEditTime: 2025-04-21 15:03:20
 * @LastEditors: ywj@originqc.com
 */
import React from "react";
import { Modal, Input, Button } from "antd";

import './index.scss';

interface ICodeprops { 
  showCodeModal: boolean;
  setShowCodeModal: React.Dispatch<React.SetStateAction<boolean>>;
  handleOk: () => void;
  setCodeVal: React.Dispatch<React.SetStateAction<string>>;
  setCodeTips: React.Dispatch<React.SetStateAction<string>>;
  codeTips: string;
}
const CodeModal: React.FC<ICodeprops> = (props) => {
  const { showCodeModal, setShowCodeModal,handleOk,setCodeVal,codeTips='',setCodeTips } = props;

  const handleIpt =(e:any)=>{
    console.log(e, e.target.value, 'eeeeeee')
    setCodeTips('');
    setCodeVal(e.target.value);
  }

  const handleCancel =()=>{
    setCodeVal('');
    setCodeTips('');
    setShowCodeModal(false);
    
    }
  return <Modal
  open={showCodeModal}
  centered
  title='优惠券兑换'
  className="coupon-modal"
  okText='是'
  cancelText='否'
  onCancel={handleCancel}
  onOk={handleOk}
  destroyOnClose={true}
>
  <p>优惠券兑换码：</p>
    <Input onChange={handleIpt} maxLength={16} />
    <span className="tips">{codeTips}</span>
  <div className="dialog-bottom">
    <Button className="submit-info" onClick={handleOk}>是</Button>
    <Button onClick={handleCancel}>否</Button>
  </div>
</Modal>;
}

export default CodeModal;
